import { BlockRegistry } from "./BlockRegistry";
import type { BlockServices } from "./BlockServices";

import { GapBlock } from "./GapBlock";
import { KeysBlock } from "./KeysBlock";

import { ExplanationBlock } from "./ExplanationBlock";
import { ImageBlock } from "./ImageBlock";
import { AudioBlock } from "./AudioBlock";
import { VideoBlock } from "./VideoBlock";


/**
 * Регистрирует все Block приложения.
 *
 * Единственное место регистрации Block.
 */
export function registerBlocks(
    registry: BlockRegistry,
    services: BlockServices
): void {

   registry.register(

        "gap",

        (task, taskIndex, store) =>
            new GapBlock(
                task as any,
                taskIndex,
                store
            )

    );

    registry.register(

        "keys",

        (task, taskIndex, store) =>
            new KeysBlock(
                task as any,
                taskIndex,
                store
            )

    );

   
    registry.register(

        "explanation",

        (task) =>
            new ExplanationBlock(
                task.html
            )

    );

    registry.register(

        "image",

        (task) =>

            new ImageBlock(
                task.src,
                task.alt,
                services.openImage
            )

    );

    registry.register(

        "audio",

        (task) =>

            new AudioBlock(
                task.url
            )

    );

    registry.register(

        "video",

        (task) =>

            new VideoBlock(
                task.url
            )

    );

}